import { gql, TypedDocumentNode } from '@apollo/client';
import { ADDRESS_FRAGMENT, RestAddress, RestAddressInput } from '../fragments.rest';

export type EditAddressMutation = {
  editAddress: {
    __typename: 'RestEditAddress';
    data: RestAddress;
  };
};

export type EditAddressMutationVariables = {
  id: string;
  input: RestAddressInput;
};

export const EDIT_ADDRESS_MUTATION: TypedDocumentNode<
  EditAddressMutation,
  EditAddressMutationVariables
> = gql`
  mutation EditAddressMutation($id: String!, $input: RestAddressInput) {
    editAddress(id: $id, input: $input)
      @rest(
        type: "RestEditAddress"
        endpoint: "user"
        path: "/addresses/{args.id}"
        method: "PATCH"
      ) {
      data @type(name: "RestAddress") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
